<div class="container-fluid-modal">
    <div class="deleteWrapper">
        <div class="ModalHeader">
            <h4 mat-dialog-title> Confirmation </h4>
            <div class="buttonWrapper">
                <button class="btn btn-danger btn-sm" (click)="deleteRecord()"><i class="fa fa-trash"
                        aria-hidden="true"></i>DELETE</button>
                <button class="btn btn-warning btn-sm" (click)="close()"> <i class="fa fa-close"
                        aria-hidden="true"></i>CANCEL</button>
            </div>
        </div>
        <div class="deleteBody">
            <div class="card">
                <div class="card-body">
                    <strong> Are you sure you want to delete this record ? </strong>
                </div>
            </div>
        </div>
    </div>
</div>